import englishMessages from 'ra-language-english';

export default {
    ...englishMessages,
    resources: {
        base: {
            name: "Base",
            fields: {
                aspect: "Aspect",
                name: "Name",
                description: "Description",
                created: "Created",
                modified: "Modified",
                origin: "Origin",
                scope: "Scope",
                type: "Type"
            }
        },
        products: {
            name: "Products",
            description: 'All products, components, instances, devices, systems, etc. are shown here.',

        },
        functions: {
            name: "Functions",
            fields: {
                type: {
                    one: "Type",
                    other: "Types"
                },
                scope: {
                    one: "Scope",
                    other: "Scopes"
                },
                fulltext: "Full text (slow)"
            },
            selectEmpty: {
                type: 'Select type',
                scope: 'Select scope'
            },
            description: 'Customer requirements, functional requests, product-independent functions can be found here.',
        },
        locations: {
            name: "Locations",
            description: 'Location coordinates, building dependencies, spatial arrangements are shown here.',
        },
        organisations: {
            name: 'Organisation |||| Organisations',
            fields: {
                name: 'Name',
                type: 'Type',
                scope: 'Scope',
                created: 'Created',
                modified: 'Modified',
            },
            description: 'Organisational information can be found here.',
        },
        types: {
            name: "Types"
        },
        scopes: {
            name: "Scopes"
        },
        aspects: {
            name: "Aspects"
        },
        tags: {
            name: "Tags"
        }
    }
};
